import { useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import Link from "next/link";
import styled from "styled-components";

const InlineFieldContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: center;
`;

const InlineFieldValue = styled.div`
  flex-grow: 1;
`;

const InlineEditField = ({
  href,
  value = null,
  validate,
  onSave,
  placeholder,
}: {
  href?: string;
  value?: string | null;
  validate?: (value: string) => boolean;
  onSave?: (value: string) => Promise<void>;
  placeholder?: string;
}) => {
  const [showEditor, setShowEditor] = useState(false);
  const [localValue, setLocalValue] = useState(value || "");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const resetEditor = () => {
    setShowEditor(false);
    setLocalValue(value || "");
    setIsSubmitting(false);
  };

  const handleClickSave = async () => {
    if (onSave) {
      setIsSubmitting(true);
      await onSave(localValue);
      setIsSubmitting(false);
    }

    setShowEditor(false);
  };

  return (
    <InlineFieldContainer>
      {showEditor ? (
        <>
          <InlineFieldValue>
            <Form.Control
              value={localValue}
              onChange={(e) => setLocalValue(e.target.value)}
              placeholder={placeholder}
              disabled={isSubmitting}
            />
          </InlineFieldValue>
          {isSubmitting && <Spinner size="sm" />}
          {!isSubmitting && (
            <>
              <Button
                className="bi-check"
                size="sm"
                onClick={handleClickSave}
                variant="outline-primary"
                disabled={validate && !validate(localValue)}
              />
              <Button
                className="bi-x"
                size="sm"
                variant="outline-secondary"
                onClick={() => resetEditor()}
              />{" "}
            </>
          )}
        </>
      ) : (
        <>
          <InlineFieldValue>
            {href ? <Link href={href}>{value}</Link> : value}
          </InlineFieldValue>
          <Button
            className="bi-pencil"
            size="sm"
            variant="outline-secondary"
            onClick={() => setShowEditor(true)}
          />
        </>
      )}{" "}
    </InlineFieldContainer>
  );
};

export default InlineEditField;
